import { render, staticRenderFns } from "./DiscountCodesTable.vue?vue&type=template&id=5dc7d73a&scoped=true&"
import script from "./DiscountCodesTable.vue?vue&type=script&lang=ts&"
export * from "./DiscountCodesTable.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCodesTable.vue?vue&type=style&index=0&id=5dc7d73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7d73a",
  null
  
)

export default component.exports